




import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { Component, Vue } from "vue-property-decorator";
import { FeatureModule } from "@/store/modules/feature.store";
import TheNavigationLayout from "./TheNavigationLayout.vue";

@Component({
  components: {
    TheNavigationLayout
  }
})
export default class TheOrganizationList extends Vue {
  ActionEnum = ActionEnum;
  ResourceEnum = ResourceEnum;

  route(route: string) {
    this.$router.push({ name: route });
  }

  get title() {
    return String(this.$t("navigation.TheOrganizationList.header"));
  }

  get isEnabled() {
    return FeatureModule.isMultipartnerAnalyticsEnabled;
  }

  get items() {
    const items = [
      {
        icon: "mdi-chart-line",
        text: "navigation.TheOrganizationList.analytics",
        link: "/organization/analytics",
        isEnabled: FeatureModule.isMultipartnerAnalyticsEnabled,
        permission: {
          resource: ResourceEnum.ANALYTICS,
          action: ActionEnum.READ
        }
      }
    ];

    return items;
  }
}
